import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import UnifiedSEO from '@/components/seo/UnifiedSEO';
import HeroSection from '@/components/features/HeroSection';
import WhatMakesDifferentSection from '@/components/features/WhatMakesDifferentSection';
import CorePillarsSection from '@/components/features/CorePillarsSection';
import GuidanceSection from '@/components/features/GuidanceSection';
import RealHomeSection from '@/components/features/RealHomeSection';
import BuiltForMajoritySection from '@/components/features/BuiltForMajoritySection';
import HowItComesTogetherSection from '@/components/features/HowItComesTogetherSection';
import PrivacyTrustSection from '@/components/features/PrivacyTrustSection';
import ClosingCTASection from '@/components/features/ClosingCTASection';

const Features = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [location.hash]);

  return (
    <>
      <UnifiedSEO
        title="Features – Home Operating System"
        description="SeniorThrive combines wellness tracking, AI-powered home safety scans, and family coordination into one connected system designed for confident living at home."
        keywords="home operating system, independent living, home safety, wellness tracking, ThriveVision, ThriveCircle, fall prevention, aging at home"
        canonical="https://seniorthrive.com/features"
        breadcrumbs={[
          { name: 'Home', url: 'https://seniorthrive.com/' },
          { name: 'Features', url: 'https://seniorthrive.com/features' },
        ]}
      />

      <div className="min-h-screen">
        <HeroSection />
        <WhatMakesDifferentSection />
        <CorePillarsSection />
        <GuidanceSection />
        <RealHomeSection />
        <BuiltForMajoritySection />
        <HowItComesTogetherSection />
        <PrivacyTrustSection />
        <ClosingCTASection />
      </div>
    </>
  );
};

export default Features;
